var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"warp",class:{
    'menu-warp': true,
    'main-backInDown': _vm.flag,
    'main-backOutUp': !_vm.flag,
  },style:({ backgroundColor: _vm.bgColor })},[_c('ul',{staticClass:"menu-list"},[_vm._l((_vm.navs),function(item){return _c('router-link',{key:item.url,attrs:{"to":item.url}},[_vm._v(" "+_vm._s(_vm.$t(`nav.${item.name}`))+" ")])}),_c('div',{staticClass:"lang_box"},[_c('span',{class:{active: _vm.$store.state.lang=='zh'},on:{"click":function($event){return _vm.onClick('en')}}},[_vm._v("EN")]),_c('span',{class:{active: _vm.$store.state.lang=='en'},on:{"click":function($event){return _vm.onClick('zh')}}},[_vm._v("中文")])])],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }